export default "__VITE_ASSET__Bek_vO$j__"